import React, { Component } from 'react';

import { getMlPriceCheck, previewMlPrice, setMlPrice } from '../utils/mlApi';

// "Precios y margen": cada publicación de MercadoLibre contra nuestro precio de lista, con
// el margen ya descontado.
//
// Contesta la pregunta que antes no tenía dónde mirarse: ¿esta publicación deja plata? Un
// juego de $590 con envío gratis pierde ~$260 en cada venta, y hasta ahora eso sólo se veía
// después, en el detalle de una venta que ya ocurrió.
//
// LA GRILLA MUESTRA POCO A PROPÓSITO. El desglose completo (costo, comisión, envío, IVA,
// bolsa) son cinco números más por fila: en 1.300 filas eso no se lee, se escanea mal y
// esconde justo la columna que importa. Van al modal, que se abre en la fila que llamó la
// atención.
//
// Los datos salen de la foto que deja "Revisar publicaciones" — el mismo barrido que
// reconcilia stock, que ya consultaba el precio de cada publicación y lo tiraba. Esta
// pantalla no consulta ML: es instantánea, y por eso la fecha del barrido va bien visible.
// El barrido es manual y no hay cron: sin esa fecha alguien fija precios con una foto vieja.

// Un importe tipeado a mano NO se interpreta: se acepta o se rechaza.
//
// "12.500" es el caso real que ya nos mordió: `parseInt` da 12, `Number` da 12,5 y un
// <input type="number"> lo acepta como válido. Las tres lecturas son distintas y ninguna es
// obviamente la correcta, así que adivinar es elegir al azar cuánto sale un juego. Se aceptan
// dígitos y, como mucho, una coma o un punto con 1-2 decimales — y si hay separador de miles,
// se rechaza y se dice por qué.
function parsearImporte(texto) {
    const limpio = String(texto == null ? '' : texto).trim();
    if (limpio === '') return { valor: null, error: null };
    if (!/^\d+([.,]\d{1,2})?$/.test(limpio)) {
        return {
            valor: null,
            error: /[.,]\d{3}/.test(limpio)
                ? 'Escribí el precio sin separador de miles: 12500, no 12.500.'
                : 'Sólo números, y como mucho dos decimales.',
        };
    }
    const valor = Number(limpio.replace(',', '.'));
    if (!(valor > 0)) return { valor: null, error: 'El precio tiene que ser mayor a 0.' };
    return { valor, error: null };
}

const money = (value) => (value == null ? '—' : `$${Math.round(Number(value)).toLocaleString('de-DE')}`);
const pct = (value) => (value == null ? '—' : `${Number(value) >= 0 ? '+' : ''}${Number(value).toFixed(1)}%`);

// Rojo / verde / gris según pidió el dueño: negativo = en ML está MÁS BARATO que en nuestra
// web. El cero exacto es gris porque no es ni una cosa ni la otra y pintarlo de un color lo
// haría parecer una señal.
function colorDiferencia(valor) {
    if (valor == null) return '#6c757d';
    if (valor < 0) return '#dc3545';
    if (valor > 0) return '#28a745';
    return '#6c757d';
}

// Los roles que pueden cambiar precios. Espeja `enpoints.js`: el editor sólo se muestra a
// quien el backend le va a aceptar la llamada. Si las dos listas se separan, el que sobra
// recibe un 1002 al tipear — y `mlApi` trata cualquier 1002 como sesión vencida, así que lo
// echa del backoffice en vez de decirle "no podés".
const ROLES_QUE_PUEDEN_CAMBIAR_PRECIO = [1, 2];

const ORDENES = [
    { key: 'margin', label: 'Peor margen' },
    { key: 'marginDesc', label: 'Mejor margen' },
    { key: 'diff', label: 'Más barato en ML' },
    { key: 'diffDesc', label: 'Más caro en ML' },
    { key: 'price', label: 'Precio ML' },
    { key: 'name', label: 'Nombre' },
];

class MlPriceCheckComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            pagination: { page: 1, limit: 50, total: 0, pages: 1 },
            totals: { listings: 0, withMargin: 0, losing: 0, withoutCost: 0, cheaperInMl: 0, inactive: 0 },
            assumptions: null,
            checkedAt: null,
            neverChecked: false,
            cargando: true,
            error: '',
            searchInput: '',
            search: '',
            sortBy: 'margin',
            onlyLosses: false,
            // Por default NO se muestran: una pausada no vende, así que su margen no es una
            // decisión pendiente. Eran 766 de 2.016 en el catálogo real — más de un tercio
            // de la grilla empujando hacia abajo a las que sí están vendiendo en pérdida.
            includeInactive: false,
            page: 1,
            detalle: null,
            // Editor de precio del modal. `preview` es lo que devolvió el backend para el
            // precio tipeado: NO se calcula acá (ver previewMlPrice).
            precioInput: '',
            precioError: '',
            preview: null,
            previewCargando: false,
            guardando: false,
            guardadoOk: '',
        };
    }

    componentDidMount() {
        this.desmontado = false;
        this.cargar();
    }

    componentWillUnmount() {
        this.desmontado = true;
        // Si se desmonta con el modal abierto (navegar desde el menú, cambiar de tab), el
        // body quedaría bloqueado para siempre y la pantalla nueva no scrollearía. Es el
        // primo del backdrop huérfano de ModalPurchase.
        this.soltarScrollDelFondo();
    }

    // El modal usa el MARKUP de Bootstrap pero no su JS, así que nadie pone
    // `body.modal-open { overflow: hidden }`. Sin esto la rueda del mouse scrollea la grilla
    // DETRÁS del modal: se cierra el desglose y quedaste en otra parte de la lista, sin
    // haber pedido moverte. Verificado en el stack aislado (scrollY pasó a 479 con el modal
    // abierto).
    bloquearScrollDelFondo = () => { document.body.style.overflow = 'hidden'; }

    soltarScrollDelFondo = () => { document.body.style.overflow = ''; }

    abrirDetalle = (r) => {
        this.bloquearScrollDelFondo();
        this.setState({
            detalle: r, precioInput: '', precioError: '', preview: null,
            previewCargando: false, guardando: false, guardadoOk: '',
        });
    }

    cerrarDetalle = () => {
        this.soltarScrollDelFondo();
        clearTimeout(this.previewTimer);
        this.setState({ detalle: null, preview: null, precioInput: '', precioError: '', guardadoOk: '' });
    }

    // ── Editor de precio ────────────────────────────────────────────────────
    //
    // El margen NO se recalcula en el cliente: se le pide al backend, con debounce. Es una
    // llamada por pausa de tecleo y garantiza que el número que ves es el que va a validar el
    // cambio. Reimplementar la cascada acá es exactamente cómo el storefront terminó mostrando
    // un envío distinto del que se cobraba.
    cambiarPrecioInput = (texto) => {
        const { valor, error } = parsearImporte(texto);
        this.setState({ precioInput: texto, precioError: error || '', preview: null, guardadoOk: '' });
        clearTimeout(this.previewTimer);
        if (valor == null) return;
        this.setState({ previewCargando: true });
        this.previewTimer = setTimeout(() => {
            previewMlPrice(this.state.detalle.externalItemId, valor)
                .then((d) => {
                    // Si el operador siguió tipeando, esta respuesta ya no corresponde al valor
                    // que está en pantalla: descartarla evita mostrar el margen de otro precio.
                    if (this.desmontado || parsearImporte(this.state.precioInput).valor !== valor) return;
                    this.setState({ preview: d, previewCargando: false });
                })
                .catch((err) => {
                    if (this.desmontado || (err && err.code === 1002)) return;
                    this.setState({ previewCargando: false, precioError: (err && err.message) || 'No se pudo calcular.' });
                });
        }, 400);
    }

    confirmarPrecio = () => {
        const { detalle, precioInput, preview } = this.state;
        const { valor } = parsearImporte(precioInput);
        if (valor == null || !preview) return;
        const ok = window.confirm(
            `Vas a cambiar el precio EN MERCADOLIBRE de "${detalle.title || detalle.externalItemId}".\n\n` +
            `${money(detalle.mlPrice)}  →  ${money(valor)}\n` +
            `Margen resultante: ${money(preview.item.margin)}\n\n` +
            'Esto modifica la publicación de verdad. ¿Confirmás?'
        );
        if (!ok) return;
        this.setState({ guardando: true, precioError: '' });
        setMlPrice(detalle.externalItemId, valor)
            .then((d) => {
                if (this.desmontado) return;
                // El detalle se reemplaza por la fila recalculada que devuelve el backend, así
                // el modal muestra el estado nuevo sin cerrarse ni re-pedir la grilla entera.
                this.setState({
                    guardando: false, precioInput: '', preview: null,
                    detalle: d.item,
                    guardadoOk: `Precio actualizado en MercadoLibre: ${money(d.previousPrice)} → ${money(d.newPrice)}.`,
                });
                this.cargar();   // la grilla de atrás también tiene que reflejarlo
            })
            .catch((err) => {
                if (this.desmontado || (err && err.code === 1002)) return;
                this.setState({ guardando: false, precioError: (err && err.message) || 'No se pudo cambiar el precio.' });
            });
    }

    cargar = () => {
        this.setState({ cargando: true, error: '' });
        const { search, sortBy, page, onlyLosses, includeInactive } = this.state;
        getMlPriceCheck({ search, sortBy, page, onlyLosses, includeInactive, limit: 50 })
            .then((data) => {
                if (this.desmontado) return;
                this.setState({ ...data, cargando: false });
            })
            .catch((err) => {
                // mlApi ya cierra la sesión ante un 1002; el panel no puede romper la pantalla.
                if (this.desmontado || (err && err.code === 1002)) return;
                this.setState({ cargando: false, error: (err && err.message) || 'No se pudo cargar.' });
            });
    }

    // Cambiar orden o filtro vuelve SIEMPRE a la página 1: si no, con 3 páginas de resultados
    // y un filtro que deja 1, la grilla queda en una página que ya no existe y se ve vacía.
    aplicar = (cambios) => this.setState({ ...cambios, page: 1 }, this.cargar);

    buscar = (e) => {
        e.preventDefault();
        this.aplicar({ search: this.state.searchInput.trim() });
    }

    irAPagina = (page) => this.setState({ page }, this.cargar);

    render() {
        const { items, totals, pagination, assumptions, cargando, error, detalle } = this.state;

        return (
            <div>
                {this.renderEncabezado()}

                {error ? <div className="alert alert-danger py-2">{error}</div> : null}

                {this.state.neverChecked ? (
                    <div className="alert alert-secondary py-2">
                        Todavía no se revisaron las publicaciones. Andá al tab
                        {' '}<b>"Regalan el envío"</b> y dale a <b>"Revisar publicaciones"</b>:
                        el mismo barrido carga esta pantalla.
                    </div>
                ) : null}

                {this.renderFiltros()}

                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>Publicación</th>
                            <th style={{ textAlign: 'right' }}>Precio ML</th>
                            <th style={{ textAlign: 'right' }}>Precio nuestro</th>
                            <th style={{ textAlign: 'right' }}>Dif.</th>
                            <th style={{ textAlign: 'right' }}>Costo</th>
                            <th style={{ textAlign: 'right' }}>Margen</th>
                            <th style={{ width: '1%' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {cargando ? (
                            <tr><td colSpan="7" className="text-muted">Cargando…</td></tr>
                        ) : items.length === 0 ? (
                            <tr><td colSpan="7" className="text-muted">No hay publicaciones para mostrar.</td></tr>
                        ) : items.map((r) => this.renderFila(r))}
                    </tbody>
                </table>

                {this.renderPaginacion(pagination)}
                {assumptions ? this.renderSupuestos(assumptions, totals) : null}
                {detalle ? this.renderModal(detalle) : null}
            </div>
        );
    }

    renderEncabezado() {
        const { totals, checkedAt } = this.state;
        return (
            <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                    <h6 className="m-0">
                        Publicaciones
                        {totals.losing > 0 ? (
                            <span className="badge badge-danger ml-2">{totals.losing} pierden plata</span>
                        ) : null}
                    </h6>
                    <small className="text-muted">
                        {totals.listings} publicación(es)
                        {totals.withoutCost > 0 ? ` · ${totals.withoutCost} sin costo cargado` : ''}
                        {totals.cheaperInMl > 0 ? ` · ${totals.cheaperInMl} más baratas en ML` : ''}
                        {!this.state.includeInactive && totals.inactive > 0
                            ? ` · ${totals.inactive} pausadas o cerradas sin mostrar` : ''}
                    </small>
                </div>
                <small className="text-muted text-right">
                    {checkedAt
                        ? <>Última revisión:<br />{new Date(checkedAt).toLocaleString('es-UY')}</>
                        : 'Sin revisión'}
                </small>
            </div>
        );
    }

    renderFiltros() {
        return (
            <div className="d-flex flex-wrap align-items-center mb-2" style={{ gap: '8px' }}>
                <form onSubmit={this.buscar} className="d-flex" style={{ gap: '4px' }}>
                    <input type="text" className="form-control form-control-sm" style={{ width: '220px' }}
                        placeholder="Nombre, MLU o código"
                        value={this.state.searchInput}
                        onChange={(e) => this.setState({ searchInput: e.target.value })} />
                    <button type="submit" className="btn btn-sm btn-outline-secondary">Buscar</button>
                </form>

                <select className="form-control form-control-sm" style={{ width: 'auto' }}
                    value={this.state.sortBy}
                    onChange={(e) => this.aplicar({ sortBy: e.target.value })}>
                    {ORDENES.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
                </select>

                <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="mlOnlyLosses"
                        checked={this.state.onlyLosses}
                        onChange={(e) => this.aplicar({ onlyLosses: e.target.checked })} />
                    <label className="custom-control-label" htmlFor="mlOnlyLosses">Sólo las que pierden</label>
                </div>

                {/* El conteo sale de `totals.inactive`, que se mide sobre el catálogo entero y
                    no sobre lo filtrado: si cambiara al buscar, se leería como el total. */}
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="mlIncludeInactive"
                        checked={this.state.includeInactive}
                        onChange={(e) => this.aplicar({ includeInactive: e.target.checked })} />
                    <label className="custom-control-label" htmlFor="mlIncludeInactive">
                        Mostrar pausadas y cerradas
                        {this.state.totals.inactive ? ` (${this.state.totals.inactive})` : ''}
                    </label>
                </div>
            </div>
        );
    }

    renderFila(r) {
        const sinMargen = r.margin == null;
        return (
            <tr key={r.externalItemId}>
                <td>
                    {r.title || '—'}
                    <br />
                    <small className="text-muted">{r.externalItemId}</small>
                    {r.freeShipping ? <span className="badge badge-light ml-2">envío gratis</span> : null}
                    {r.status && r.status !== 'active'
                        ? <span className="badge badge-secondary ml-2">{r.status}</span> : null}
                </td>
                <td style={{ textAlign: 'right' }}>{money(r.mlPrice)}</td>
                <td style={{ textAlign: 'right' }}>
                    {money(r.ourPrice)}
                    {/* Un producto en oferta parece tener el precio roto si no se dice que
                        nuestro precio ya trae el descuento del catálogo. */}
                    {r.ourDiscountPct > 0
                        ? <><br /><small className="text-muted">lista {money(r.ourListPrice)} −{r.ourDiscountPct}%</small></>
                        : null}
                </td>
                <td style={{ textAlign: 'right', color: colorDiferencia(r.priceDiff), fontWeight: 500 }}>
                    {pct(r.priceDiffPct)}
                    <br /><small>{r.priceDiff == null ? '' : money(r.priceDiff)}</small>
                </td>
                <td style={{ textAlign: 'right' }}>{money(r.totalCost)}</td>
                <td style={{ textAlign: 'right', fontWeight: 500, color: sinMargen ? '#6c757d' : (r.margin < 0 ? '#dc3545' : '#28a745') }}>
                    {sinMargen ? '—' : money(r.margin)}
                    {sinMargen ? null : <><br /><small>{pct(r.marginPct)}</small></>}
                </td>
                <td>
                    <button type="button" className="btn btn-sm btn-outline-secondary"
                        onClick={() => this.abrirDetalle(r)}>Desglose</button>
                </td>
            </tr>
        );
    }

    renderPaginacion({ page, pages, total }) {
        if (pages <= 1) return null;
        return (
            <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                <button type="button" className="btn btn-sm btn-outline-secondary"
                    disabled={page <= 1} onClick={() => this.irAPagina(page - 1)}>Anterior</button>
                <small className="text-muted">Página {page} de {pages} ({total} publicaciones)</small>
                <button type="button" className="btn btn-sm btn-outline-secondary"
                    disabled={page >= pages} onClick={() => this.irAPagina(page + 1)}>Siguiente</button>
            </div>
        );
    }

    // Los supuestos van a la vista, no escondidos: el margen es una ESTIMACIÓN pesimista y
    // sin saber con qué se calculó no se puede discutir ni corregir.
    renderSupuestos(a, totals) {
        const tasa = `${(Number(a.tasaComision) * 100).toFixed(2).replace('.', ',')}%`;
        return (
            <div className="alert alert-light py-2 mt-3 mb-0" style={{ fontSize: '0.85rem' }}>
                <b>Cómo se calcula.</b> Comisión de ML: <b>{tasa}</b> del precio
                {' '}{this.origenDeLaTasa(a.source)}
                {' '}más un cargo fijo en las de menos de $1.000 ($40 · $25 · $15 según el tramo).
                {' '}ML a veces bonifica la mitad de la comisión; acá va siempre la tarifa <b>plena</b>,
                que es el lado pesimista.
                {' '}Envío: <b>{money(a.envioPeorCaso)}</b> sólo si la publicación tiene envío gratis
                {' '}(la zona más cara del tarifario), <b>$0</b> si no lo tiene — ahí lo paga el comprador.
                {' '}Bolsa: <b>{money(a.costoBolsa)}</b> (la más cara). IVA: 22/122 sobre lo que queda
                {' '}<b>después</b> de comisión y envío — esos dos vienen facturados con IVA y también
                {' '}dan crédito fiscal. Si la publicación pierde plata, el IVA aparece <b>a favor</b>.
                {' '}El <b>desglose</b> de cada fila muestra además el mismo cálculo con el envío y la
                {' '}bolsa <b>promedio</b>, para ver si el resultado depende del peor caso o no.
                {totals.withoutCost > 0 ? (
                    <> <b className="text-warning">{totals.withoutCost} publicación(es) sin costo cargado</b>:
                    {' '}el margen no se puede calcular y quedan al final de la lista.</>
                ) : null}
            </div>
        );
    }

    // Tres orígenes, tres textos. Decir "medida de las ventas reales" cuando NO se pudo medir
    // —una base sin ventas de ML todavía— convierte un default en un dato, que es justo lo que
    // el resto de esta pantalla se cuida de no hacer.
    origenDeLaTasa(source) {
        if (source && source.commissionFromConfig) return '(fijada a mano)';
        if (source && source.commissionMeasured) return '(medida de las ventas reales)';
        return '(valor por defecto: todavía no hay ventas de ML para medirla)';
    }


    // El control de precio vive ACÁ y no en la grilla a propósito: lo que hace útil a este
    // botón es ver el margen ANTES de confirmar. Suelto en una fila sería "cambiar un número";
    // acá es "elegir un margen".
    renderEditorDePrecio(r) {
        if (!ROLES_QUE_PUEDEN_CAMBIAR_PRECIO.includes(Number(this.props.role))) return null;

        const { precioInput, precioError, preview, previewCargando, guardando, guardadoOk } = this.state;
        const { valor } = parsearImporte(precioInput);
        const nuevoMargen = preview && preview.item ? preview.item.margin : null;
        const quedaNegativo = nuevoMargen != null && nuevoMargen < 0;
        // `writeEnabled` viene del backend: staging comparte las publicaciones reales con
        // producción, así que ahí el botón tiene que estar apagado CON EL MOTIVO a la vista —
        // si no, se lee como que la pantalla está rota.
        const puedeEscribir = preview ? preview.writeEnabled !== false : true;

        return (
            <div className="modal-body pt-0">
                <hr className="mt-0" />
                <label className="d-block mb-1"><b>Cambiar el precio en MercadoLibre</b></label>

                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <div className="input-group input-group-sm" style={{ width: '180px' }}>
                        <div className="input-group-prepend"><span className="input-group-text">$</span></div>
                        {/* type="text" y no "number": el spinner invita a tocar el precio con la
                            rueda del mouse, y acá cada cambio es una escritura a ML. El formato
                            lo valida `parsearImporte`. */}
                        <input type="text" inputMode="decimal" className="form-control"
                            placeholder={String(Math.round(r.mlPrice || 0))}
                            value={precioInput} disabled={guardando}
                            onChange={(e) => this.cambiarPrecioInput(e.target.value)} />
                    </div>
                    <button type="button" className="btn btn-sm btn-primary"
                        disabled={!valor || !preview || quedaNegativo || guardando || previewCargando || !puedeEscribir}
                        onClick={this.confirmarPrecio}>
                        {guardando ? 'Guardando…' : 'Cambiar en ML'}
                    </button>
                    {previewCargando ? <small className="text-muted">calculando…</small> : null}
                </div>

                {precioError ? <div className="alert alert-danger py-1 px-2 mt-2 mb-0">{precioError}</div> : null}
                {guardadoOk ? <div className="alert alert-success py-1 px-2 mt-2 mb-0">{guardadoOk}</div> : null}

                {preview && preview.item ? (
                    <div className="mt-2">
                        <div className="d-flex justify-content-between">
                            <span>Margen a {money(valor)}</span>
                            <span style={{ fontWeight: 600, color: quedaNegativo ? '#dc3545' : '#28a745' }}>
                                {money(nuevoMargen)} ({pct(preview.item.marginPct)})
                            </span>
                        </div>
                        {/* El tope: no tiene sentido fijar a mano un precio que pierde plata. El
                            backend lo rechaza igual (6903); acá se apaga el botón y se dice el
                            mínimo, que es lo accionable. */}
                        {quedaNegativo ? (
                            <div className="alert alert-warning py-1 px-2 mt-1 mb-0">
                                A ese precio la publicación <b>pierde plata</b>.
                                {preview.minimumPrice
                                    ? <> El mínimo para no perder es <b>{money(preview.minimumPrice)}</b>.</>
                                    : null}
                            </div>
                        ) : null}
                    </div>
                ) : null}

                {preview && preview.writeEnabled === false ? (
                    <div className="alert alert-secondary py-1 px-2 mt-2 mb-0">
                        <b>Sólo lectura en este entorno.</b> Staging comparte las publicaciones
                        reales con producción, así que el cambio de precios se habilita únicamente
                        en producción.
                    </div>
                ) : null}
            </div>
        );
    }

    renderModal(r) {
        const cerrar = this.cerrarDetalle;
        const b = r.breakdown || {};
        // Un valor negativo se muestra como lo que es —un crédito, con signo +— y no como
        // `− $-9`. Pasa de verdad: si el producto se vende por debajo del costo el margen
        // bruto es negativo y el IVA se vuelve crédito fiscal (visto en prod: Pathfinder a
        // $3.990 con costo $4.011). Ese doble signo hace dudar de toda la columna.
        const linea = (label, valor, extra = null) => (
            <tr>
                <td>{label}{extra ? <><br /><small className="text-muted">{extra}</small></> : null}</td>
                <td style={{ textAlign: 'right' }}>
                    {valor == null ? '—' : (valor < 0 ? `+ ${money(-valor)}` : `− ${money(valor)}`)}
                </td>
            </tr>
        );
        const detalleComision = b.commissionDetail
            ? `${(b.commissionDetail.rate * 100).toFixed(2).replace('.', ',')}% de ${money(r.mlPrice)}`
              + `${b.commissionDetail.fixed ? ` + ${money(b.commissionDetail.fixed)} de cargo fijo` : ''}`
            : null;

        return (
            <>
                {/* Modal controlado por React, sin el JS de Bootstrap: acá no se navega a otra
                    pantalla, así que no hay backdrop huérfano que limpiar (ver ModalPurchase). */}
                {/* `overflowY: auto` va a mano: Bootstrap se lo pone al `.modal` desde su JS
                    al abrirlo, y su CSS lo deja en `hidden`. Sin esto, un desglose con varias
                    notas en una pantalla baja queda cortado y sin forma de bajar. */}
                <div className="modal fade show" style={{ display: 'block', overflowY: 'auto' }} role="dialog" onClick={cerrar}>
                    <div className="modal-dialog modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title">{r.title || r.externalItemId}</h6>
                                <button type="button" className="close" onClick={cerrar}>&times;</button>
                            </div>
                            <div className="modal-body">
                                <table className="table table-sm mb-2">
                                    <tbody>
                                        <tr>
                                            <td><b>Precio en MercadoLibre</b></td>
                                            <td style={{ textAlign: 'right' }}><b>{money(r.mlPrice)}</b></td>
                                        </tr>
                                        {linea('Costo del producto', b.productCost)}
                                        {linea('Bolsa', b.bagCost, 'la más cara de las marcadas')}
                                        {linea('Comisión de MercadoLibre', b.commission, detalleComision)}
                                        {linea('Envío', b.shipping, r.freeShipping
                                            ? 'la publicación tiene envío gratis: el flete es nuestro'
                                            : 'sin envío gratis: lo paga el comprador')}
                                        {linea('IVA', b.vat, b.vat != null && b.vat < 0
                                            ? '22/122 sobre lo que queda: como la operación pierde, el IVA es crédito'
                                            : '22/122 sobre lo que queda después de comisión y envío')}
                                        <tr style={{ borderTop: '2px solid #dee2e6' }}>
                                            <td><b>Margen</b></td>
                                            <td style={{ textAlign: 'right', fontWeight: 600, color: r.margin == null ? '#6c757d' : (r.margin < 0 ? '#dc3545' : '#28a745') }}>
                                                {r.margin == null ? '—' : `${money(r.margin)} (${pct(r.marginPct)})`}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                {/* Segundo escenario: los mismos números con el envío y la
                                    bolsa PROMEDIO en vez del peor caso. Separa "esto pierde
                                    plata" de "esto pierde plata sólo si sale por la zona más
                                    cara". No va a la grilla: ahí se ordena por margen y dos
                                    columnas de margen no se pueden ordenar a la vez. */}
                                {r.averageScenario ? (
                                    <div className="mb-2 p-2" style={{ background: 'rgba(0,0,0,.03)', borderRadius: '4px' }}>
                                        <small className="text-muted d-block mb-1">
                                            <b>Con costos promedio</b> en vez del peor caso —
                                            {' '}envío {money(r.averageScenario.shipping)}
                                            {r.freeShipping ? ' (zona típica)' : ' (no tiene envío gratis)'},
                                            {' '}bolsa {money(r.averageScenario.bagCost)}:
                                        </small>
                                        <div className="d-flex justify-content-between align-items-baseline">
                                            <span>Margen</span>
                                            <span style={{ fontWeight: 600, color: r.averageScenario.margin < 0 ? '#dc3545' : '#28a745' }}>
                                                {money(r.averageScenario.margin)} ({pct(r.averageScenario.marginPct)})
                                            </span>
                                        </div>
                                        {/* La diferencia es el dato que decide: si es chica, el
                                            resultado no depende del supuesto de envío. */}
                                        {r.margin != null ? (
                                            <small className="text-muted">
                                                {r.averageScenario.margin < 0 && r.margin < 0
                                                    ? 'Pierde plata en los dos escenarios.'
                                                    : (r.margin < 0
                                                        ? 'Con costos promedio deja de perder: el resultado depende de a qué zona se envíe.'
                                                        : 'Gana en los dos escenarios.')}
                                                {' '}Diferencia: {money(Math.abs(r.averageScenario.margin - r.margin))}.
                                            </small>
                                        ) : null}
                                    </div>
                                ) : null}

                                <small className="text-muted d-block">
                                    Nuestro precio: {money(r.ourPrice)}
                                    {r.ourDiscountPct > 0 ? ` (lista ${money(r.ourListPrice)} menos ${r.ourDiscountPct}%)` : ''}
                                    {/* El cero exacto es frecuente (el precio de ML se carga
                                        igual al de lista) y "está $0 más caro" se lee como un
                                        error de cuenta. */}
                                    {r.priceDiff == null ? '' : (r.priceDiff === 0
                                        ? ' · mismo precio que en ML'
                                        : ` · en ML está ${money(Math.abs(r.priceDiff))} ${r.priceDiff > 0 ? 'más caro' : 'más barato'}`)}
                                </small>
                                {r.logisticType ? (
                                    <small className="text-muted d-block">Logística: {r.logisticType}
                                        {r.mandatoryFreeShipping ? ' · envío gratis obligatorio de ML' : ''}</small>
                                ) : null}

                                {(r.notas || []).length > 0 ? (
                                    <div className="alert alert-warning py-2 mt-2 mb-0">
                                        {r.notas.map((n, i) => <div key={i}>{n}</div>)}
                                    </div>
                                ) : null}
                            </div>
                            {this.renderEditorDePrecio(r)}

                            <div className="modal-footer">
                                <a className="btn btn-sm btn-outline-secondary"
                                    href={`https://articulo.mercadolibre.com.uy/${String(r.externalItemId).replace('MLU', 'MLU-')}`}
                                    target="_blank" rel="noopener noreferrer">Ver en MercadoLibre</a>
                                <button type="button" className="btn btn-sm btn-secondary" onClick={cerrar}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }
}

export default MlPriceCheckComponent;
